<!-- Loading bar -->
<fuse-loading-bar></fuse-loading-bar>

<!-- Navigation -->
<fuse-vertical-navigation
    class="crm-nav dark bg-gray-900 print:hidden"
    [mode]="isScreenSmall ? 'over' : 'side'"
    [name]="'mainNavigation'"
    [navigation]="navigation?.default"
    [opened]="!isScreenSmall"
>
    <!-- Navigation header hook : logo et nom de l'application -->
    <ng-container fuseVerticalNavigationContentHeader>
        <div class="flex h-16 w-full items-center gap-3 px-5">
            <img class="h-9 w-9 rounded-lg bg-white object-contain p-0.5" src="images/logo/logo-crm.jpg" alt="" />
            <div class="leading-tight">
                <div class="text-base font-semibold text-white">Phoenix CRM</div>
                <div class="text-xs text-gray-400">Mosofty</div>
            </div>
        </div>
        <div class="mx-5 mb-2 border-t border-white/10"></div>
    </ng-container>

    <!-- Navigation footer hook : utilisateur connecté -->
    <ng-container fuseVerticalNavigationFooter>
        <div class="flex w-full items-center gap-3 border-t border-white/10 px-4 py-3">
            @if (user?.avatar) {
                <img class="h-9 w-9 flex-0 rounded-full object-cover" [src]="user.avatar" alt="" />
            } @else {
                <div class="flex h-9 w-9 flex-0 items-center justify-center rounded-full bg-primary-600 text-sm font-semibold uppercase text-white">
                    {{ (user?.name || user?.fullName || user?.email || '?').charAt(0) }}
                </div>
            }
            <div class="min-w-0 flex-auto leading-tight">
                <div class="truncate text-md font-medium text-gray-100">{{ user?.name || user?.fullName || 'Mon compte' }}</div>
                <div class="truncate text-sm text-gray-400">{{ user?.email }}</div>
            </div>
            <user [showAvatar]="false"></user>
        </div>
    </ng-container>
</fuse-vertical-navigation>

<!-- Wrapper -->
<div class="flex w-full min-w-0 flex-auto flex-col">
    <!-- Message si la société n'est pas activée (uniquement pour les companies) -->
    @if (!isCompanyEnabled && _authService.isCompany() && companyId) {
        <div class="bg-warn text-white p-2 text-center">
            <span>Votre société n'est pas encore activée. Veuillez <a [routerLink]="['/companies/edit', companyId]" class="underline cursor-pointer">compléter les champs requis</a> pour activer votre compte.</span>
        </div>
    }
    <!-- Message si la candidature n'est pas activée (uniquement pour les candidates) -->
    @if (!isCondidateEnabled && _authService.isCandidate()) {
        <div class="bg-warn text-white p-2 text-center">
            <span>Votre Condidature n'est pas encore activée. Veuillez <a [routerLink]="['/candidates/edit', condidateId]" class="underline">compléter les champs requis</a> pour activer votre compte.</span>
        </div>
    }
    <!-- Header -->
    <div
        class="bg-card relative z-49 flex h-16 w-full flex-0 items-center border-b px-4 dark:bg-transparent md:px-6 print:hidden"
    >
        <!-- Navigation toggle button -->
        <button mat-icon-button (click)="toggleNavigation('mainNavigation')">
            <mat-icon svgIcon="heroicons_outline:bars-3"></mat-icon>
        </button>
        <!-- Components -->
        <div class="ml-auto flex items-center space-x-0.5 pl-2 sm:space-x-2">
            <search [appearance]="'bar'"></search>
            <shortcuts></shortcuts>
            <messages></messages>
            <notifications></notifications>
            <fuse-fullscreen class="hidden md:block"></fuse-fullscreen>
            <button
                class="lg:hidden"
                mat-icon-button
                (click)="quickChat.toggle()"
            >
                <mat-icon
                    svgIcon="heroicons_outline:chat-bubble-left-right"
                ></mat-icon>
            </button>
        </div>
    </div>

    <!-- Content -->
    <div class="flex flex-auto flex-col">
        <!-- *ngIf="true" hack is required here for router-outlet to work correctly.
             Otherwise, layout changes won't be registered and the view won't be updated! -->
        @if (true) {
            <router-outlet></router-outlet>
        }
    </div>

    <!-- Footer -->
    <!--<div class="relative flex flex-0 items-center justify-start w-full h-14 px-4 md:px-6 z-49 border-t bg-card dark:bg-transparent print:hidden">
        <span class="font-medium text-secondary">Fuse &copy; {{currentYear}}</span>
    </div>-->
</div>

<!-- Quick chat -->
<quick-chat #quickChat="quickChat"></quick-chat>
